var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorCodeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H31.9852C40.8218 0 47.9852 7.16344 47.9852 16V31.9852C47.9852 40.8218 40.8218 47.9852 31.9852 47.9852H16C7.16344 47.9852 0 40.8218 0 31.9852V16Z",
    fill: "#FEF2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9842 33.9895C29.5054 33.9895 33.9811 29.5138 33.9811 23.9926C33.9811 18.4715 29.5054 13.9957 23.9842 13.9957C18.4631 13.9957 13.9873 18.4715 13.9873 23.9926C13.9873 29.5138 18.4631 33.9895 23.9842 33.9895Z",
    stroke: "#E7000B",
    strokeWidth: 1.99938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9839 19.9938V23.9926",
    stroke: "#E7000B",
    strokeWidth: 1.99938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9839 27.9914H23.9939",
    stroke: "#E7000B",
    strokeWidth: 1.99938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCodeIcon);
export default __webpack_public_path__ + "static/media/error_code_icon.594f3cae1f6b5839b508af42f3871be1.svg";
export { ForwardRef as ReactComponent };